import { useQuery } from '@apollo/client';

import { SocialInteractionTargetViewCounterDocument } from '../graphql';

type ViewCounter = {
  viewsCount: number;
};

export const useViewCounter = (urn: string): ViewCounter => {
  const { data } = useQuery(SocialInteractionTargetViewCounterDocument, {
    fetchPolicy: 'no-cache',
    variables: { urn },
  });

  return { viewsCount: data?.viewer?.socialInteractionTarget?.viewsCount ?? 0 };
};
